// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"77a1df30","732":"fcc18aba","977":"39f4efed"}[chunkId] + ".chunk.js";
};